import { render, staticRenderFns } from "./ActiveUserListSessionInfo.vue?vue&type=template&id=11853a35&scoped=true&"
import script from "./ActiveUserListSessionInfo.vue?vue&type=script&lang=ts&"
export * from "./ActiveUserListSessionInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ActiveUserListSessionInfo.vue?vue&type=style&index=0&id=11853a35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11853a35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11853a35')) {
      api.createRecord('11853a35', component.options)
    } else {
      api.reload('11853a35', component.options)
    }
    module.hot.accept("./ActiveUserListSessionInfo.vue?vue&type=template&id=11853a35&scoped=true&", function () {
      api.rerender('11853a35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ActiveUserListSessionInfo.vue"
export default component.exports